export namespace Filters {
	export enum LocalStorageKeys {
		FiltersGroupSettingsPrefix = 'perito_filters_filtersGroupSettings',
	}
}
